import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { ITreeStructure } from "@/shop/types/tree";

import * as TreeActions from "./actions";
import type { ITreeReducerState } from "./types";

export type TreeAction = ActionType<typeof TreeActions>;

const initialState: ITreeReducerState = {
  trees: {},
  hasError: {},
  isFetching: {}
};

interface ITreeUpdate {
  tree: ITreeStructure;
  hasError: boolean;
  isFetching: boolean;
}

function updateTreeState(state: ITreeReducerState, url: string, { tree, hasError, isFetching }: ITreeUpdate): ITreeReducerState {
  return {
    ...state,
    trees: {
      ...state.trees,
      [url]: tree
    },
    isFetching: {
      ...state.isFetching,
      [url]: isFetching
    },
    hasError: {
      ...state.hasError,
      [url]: hasError
    }
  };
}

export default function partTreeReducer(state = initialState, action: TreeAction): ITreeReducerState {
  switch (action.type) {
    case getType(TreeActions.fetchTreeStart): {
      const { url } = action.payload;
      return updateTreeState(state, url, { isFetching: true, hasError: false, tree: null! });
    }

    case getType(TreeActions.fetchTreeFail): {
      const { url } = action.payload;
      return updateTreeState(state, url, { isFetching: false, hasError: true, tree: null! });
    }

    case getType(TreeActions.fetchTreeSuccess): {
      const { url, tree } = action.payload;
      return updateTreeState(state, url, { isFetching: false, hasError: false, tree });
    }

    default:
      return state;
  }
}
